import { fontSizes } from './fontSizes';

const parentTypography = {
  fontSize: 14,
  h1: {
    fontSize: `${fontSizes.h1} !important`
  },
  h2: {
    fontSize: `${fontSizes.h2} !important`
  },
  h3: {
    fontSize: `${fontSizes.h3} !important`,
    fontWeight: 600
  },
  h4: {
    fontSize: `${fontSizes.h4} !important`,
    fontWeight: 500
  },
  h5: {
    fontWeight: 500,
    fontSize: `${fontSizes.h5} !important`
  },
  h6: {
    fontSize: `${fontSizes.h6} !important`
  },
  body2: {
    fontSize: `${fontSizes.default} !important`,
    lineHeight: '22px'
  },
  body1: {
    fontSize: `${fontSizes.default} !important`,
    lineHeight: '22px'
  },
  subtitle2: {
    fontSize: `${fontSizes.subtitle} !important`,
    fontWeight: 400
  },
  subtitle1: {
    fontSize: `${fontSizes.smallText} !important`,
    fontWeight: 400
  }
};

export default parentTypography;
